import React, { useState } from 'react';
import { db } from '../services/firebase';
import { doc, getDoc } from 'firebase/firestore';
import './Login.css';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import bcrypt from 'bcryptjs';

const Login = () => {
  const [mobile, setMobile] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();
  const { setUser } = useAuth();

  // Login with mobile and password (no OTP)
  const handleLogin = async () => {
    if (loading) return;

    if (mobile.length !== 10) {
      alert("Enter a valid 10-digit mobile number");
      return;
    }

    if (!password) {
      alert("Please enter your password");
      return;
    }

    setLoading(true);
    setError("");

    try {
      // Find superadmin by mobile
      const docRef = doc(db, 'superadmins', mobile);
      const docSnap = await getDoc(docRef);

      if (!docSnap.exists()) {
        alert("Super Admin not found with this mobile number");
        setLoading(false);
        return;
      }

      const data = docSnap.data();
      
      // Verify password with bcrypt
      const isMatch = await bcrypt.compare(password, data.passwordHash);
      if (!isMatch) {
        alert("Incorrect password");
        setLoading(false);
        return;
      }

      localStorage.setItem("superadmin", mobile);
      setUser({ mobile }); // Update auth context
      alert("Login successful");
      nav("/homepage");

    } catch (err) {
      console.error("Login error:", err);
      setError(err.message || "Login failed");
      alert("Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrapper">
      {/* <img src="/logo.png" alt="Logo" className="logo" /> */}
      <h1 className="title">JMI</h1>
      <p className="subtitle">Super Admin</p>

      <div className="login-box">
        <h2>Super Admin Login</h2>

        <label>Super Admin ID</label>
        <input
          type="tel"
          maxLength="10"
          placeholder="Enter Mobile Number"
          value={mobile}
          onChange={(e) => setMobile(e.target.value.replace(/\D/, ''))}
        />

        <label>Password</label>
        <input
          type="password"
          placeholder="Enter your password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <button
          className="login-btn"
          onClick={handleLogin}
          disabled={loading}
        >
          {loading ? "Logging in..." : "Login"}
        </button>

        <p className="forgot" onClick={() => nav("/forgetpassword")}>
          Forgot Password?
        </p>
      </div>

      {error && <p className="error">{error}</p>}

      <p className="register-link">
        Don't have an account? <span onClick={() => nav("/register")}>Register now</span>
      </p>

      <p className="support">
        <img src="/whatsapp.svg" alt="whatsapp" className="whatsapp-icon" />
        Need help? Contact Seller Support
      </p>
    </div>
  );
};

export default Login;